import * as server from '../entries/pages/view/_id_integer_/_page.server.ts.js';

export const index = 40;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/view/_id_integer_/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/view/[id=integer]/+page.server.ts";
export const imports = ["_app/immutable/nodes/40.IFWntMpk.js","_app/immutable/chunks/Bzak7iHL.js","_app/immutable/chunks/69_IOA4Y.js","_app/immutable/chunks/DIeogL5L.js","_app/immutable/chunks/CnGaPG_y.js","_app/immutable/chunks/7JdHMB9Z.js","_app/immutable/chunks/BqhvobEz.js","_app/immutable/chunks/DSFu6lmr.js","_app/immutable/chunks/Dsy9VFq4.js","_app/immutable/chunks/BBilxCvN.js","_app/immutable/chunks/CAN0e4T3.js","_app/immutable/chunks/_bkH3ryn.js","_app/immutable/chunks/Bu9wkQ5s.js"];
export const stylesheets = ["_app/immutable/assets/40.CKjMHHoq.css"];
export const fonts = [];
